// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/cloud-arrow-up.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/cloud-arrow-up'

import { Icon, type IconComponentProps } from '../icon'

export const CloudArrowUpIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
